import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Option } from '../select-field/select-field.component';

@Component({
  selector: 'app-caretime-field',
  templateUrl: './caretime-field.component.html',
  styleUrls: ['./caretime-field.component.scss'],
})
export class CaretimeFieldComponent {
  @Input() label!: string;
  @Input() placeholder: string = '選択して下さい';
  @Input() cancel?: string;
  @Output() formChange = new EventEmitter<FormControl>();

  required: boolean = false;
  options: Option[];

  private _form!: FormControl;
  @Input()
  get form(): FormControl {
    return this._form;
  }
  set form(form: FormControl) {
    this._form = form;
    this.required = form.hasValidator(Validators.required);
  }

  constructor() {
    this.options = [...Array(25)].map((_, i) => {
      return { name: `${i * 5}分` };
    });
  }

  onChange(): void {
    this.formChange.emit(this.form);
  }
}
